import CustomerOverviewModule from './CustomerOverview.module';

export default CustomerOverviewModule;
